import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

// Old QR links (already sent in emails) point here; the bib page now uses a numeric key.
export const Route = createFileRoute("/gestion_/validar")({
  validateSearch: (s) => z.object({ t: z.string().optional() }).parse(s),
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/dorsales", search: { t: search.t } });
  },
});
